import { render } from "./SequenceCard.vue?vue&type=template&id=ac901e7c&scoped=true"
import script from "./SequenceCard.vue?vue&type=script&lang=js"
export * from "./SequenceCard.vue?vue&type=script&lang=js"

import "./SequenceCard.vue?vue&type=style&index=0&id=ac901e7c&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac901e7c"]])

export default __exports__